/**
 * Directive for the Edit Portal Page Description section.
 */
SUGApp.directive("sugBanner", function() {
    return({
        restrict: "A",
        templateUrl: "/view/tools/portals/dspSectionBanner.html",
        scope: {
            data: '=',
            section: '='
        },
        link: function($scope, elm, attrs) {

            /**
             * This a from the sbContainer directive
             * Since we already have a directive here, we just added this section from it
             * It takes care of recalucations, in this case it occurs when the window changes size.
             **/
            var w = angular.element(window);
            $scope.$watch(
                function () {
                    return ( elm[0].id + elm[0].clientWidth + elm[0].clientHeight );
                },
                function(newValue, oldValue) {

                    if (newValue !== oldValue ) {
                        $scope.responsiveUpdates();
                    }

                }, true );

                //allows directive to receive updates when window is resized
                w.bind('resize', function () {
                    $scope.$apply();
                });
            },

        controller:['$scope','SUGUtilities','errorService','portalService',
        function(   $scope , SUGUtilities , errorService , portalService) {
            // $scope refers to scope of this perticular directive instance.
            //init error service
            $scope.es = errorService;
            $scope.es.init();

            /* Data Object with Image properties */
            $scope.imagedata = {};

            $scope.responsiveUpdates = function() {

                //1 update coordinates
                updateCropCoordinates();

                //2 setup wrapper
                setupContentWrapper();
            };

            /**
             * Listen for the files save event from the slide out so you can update the instance view
             */
            $scope.$on('portal_savebanner', function (evt,val) {
                //if the event has a valid value and is for this specific section instance, then update view
                if(    typeof val === "object"
                    && typeof val.sectionId !== 'undefined'
                    && val.sectionId == $scope.section.id
                    && typeof val.imagedata !== 'undefined'
                    && Object.keys(val.imagedata).length > 0
                    )
                {
                    /* A full imagedata model then just this */
                    $scope.imagedata = val.imagedata;

                    //1 update coords
                    updateCropCoordinates();

                    //2 setup wrapper
                    setupContentWrapper();

                }
            });

            //Set dynamic disable and processing vars so you only impact a specific directive instance
            $scope['frmDisableField'+$scope.section.id] = false;
            $scope['isProcessing'+$scope.section.id] = false;

            // Handler for Processing Status
            $scope.$on('isProcessingBanner', function (event, objProcessing) {
                //Verify the event has a valid object and is for this specific section instance
                if(    typeof objProcessing === "object"
                && typeof objProcessing.sectionId !== 'undefined'
                && typeof objProcessing.isprocessing !== 'undefined'
                && objProcessing.sectionId == $scope.section.id){
                    $scope['isProcessing'+$scope.section.id] = objProcessing.isprocessing;
                    disableForm(objProcessing.isprocessing);
                }
            });

            //manage disabling the form
            var disableForm = function (blnDisabled) {
                $scope['frmDisableField'+$scope.section.id] = blnDisabled;
            };

            /**
             * Method sets up the content wrapper for cropping
             */
            var setupContentWrapper = function() {
                var backgroundimages = ['A','B','C','D','E'];
                var rnd = Math.floor((Math.random() * 5));
                var bannerid = $scope.imagedata.serverfilename;

                //decimals messup the identifier
                bannerid = bannerid.replace('.','');

                /**
                 * Here we are creating a unique identifier for our image.
                 * it is based on coordinates, a random identifier
                 * and the serverfilename without the decimal
                 **/
                if ( $scope.imagedata.imagecropcoords.length === 6 ) {
                    $scope.bannerimageid = String(
                        'bannerimage_' +
                        backgroundimages[rnd] + '_' +
                        bannerid + '_' +
                        $scope.imagedata.imagecropcoords[0] +
                        $scope.imagedata.imagecropcoords[1] +
                        $scope.imagedata.imagecropcoords[2] +
                        $scope.imagedata.imagecropcoords[3] +
                        $scope.imagedata.imagecropcoords[4] +
                        $scope.imagedata.imagecropcoords[5]
                    );

                    $scope.aspectRatio = Math.round( ( $scope.imagedata.imagecropcoords[4] / $scope.imagedata.imagecropcoords[5] ) * 10 ) / 10;
                    $scope.aspectRatio = $scope.aspectRatio;

                //if coordinates are not found use this for the id, occurence is unlikely
                } else if ( bannerid.length ) {
                    $scope.bannerimageid = String('bannerimage_' + backgroundimages[rnd] + '_ ' + bannerid);
                //if image id is not found use this for the id, should not occur
                } else {
                    $scope.bannerimageid = String('bannerimage_' + backgroundimages[rnd]);
                }

                //toggle spinner and form disable (from parseData > loadData)
                SUGUtilities.broadCast('isProcessingBanner', { 'sectionId': $scope.section.id, 'isprocessing': false });
            };

            /**
             * Method loads the info for the section directive from main data model
             */
            var parseData = function(){
                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessingBanner', { 'sectionId': $scope.section.id, 'isprocessing': true });

                loadData();
            };

            /**
             * Method loads the data from the service if parseData() yields no values
             */
            var loadData = function(){

                portalService.getBannerSectionData({
                              //This value works with subadmins too
                              owner: $scope.data.portalInfo.portal.memberid
                            , portalID: $scope.section.portalid
                            , portalSectionID: $scope.section.id
                    }).then(function( response ){
                    //validate the response
                    if( SUGUtilities.ajaxResultInvalid( response.data ) ){
                        //toggle spinner and form disable
                        SUGUtilities.broadCast('isProcessingBanner', { 'sectionId': $scope.section.id, 'isprocessing': false });

                        $scope.es.setError('portal-banner-preview', SUGUtilities.getAjaxResponseMessage(response) );
                    } else {
                        //response was valid
                        var r = SUGUtilities.lowerCaseKeys( response.data );
                        if( r.success && Object.keys(r.data).length ){
                            $scope.imagedata = r.data;

                            //1 update coordindates
                            updateCropCoordinates();

                            //2 setup wrapper
                            setupContentWrapper();

                            //spinner/form toggled in setupContentWrapper()
                        }
                    }
                });
            };

            /**
             * Update the crop coordinates for the view
             */
            var updateCropCoordinates = function(){
                $scope.section.clientfilename = ( $scope.imagedata.clientfilename ) ? $scope.imagedata.clientfilename : "";

                var coords;
                coords = $scope.imagedata.imagecropcoords;

                var cw,ch;

                //size of the container
                cw = angular.element('#' + $scope.bannerimageid).width();
                ch = angular.element('#' + $scope.bannerimageid).height();

                //guard if the data is not ready, return
                if (cw < 1 || ch < 1 || coords.length !== 6 ) {
                    return;
                }

                if ( coords ) {
                    var x1 = coords[0];
                    var y1 = coords[1];
                    var coordw = coords[4];
                    var coordh = coords[5];

                    //set coordinates
                    var width = $scope.imagedata.imagewidth;
                    var height = $scope.imagedata.imageheight;

                    /* Update Coords in the UI */
                    $scope.resizing = {};
                    $scope.resizing.left = ( cw / coordw ) * x1 * -1;
                    $scope.resizing.top = ( ch / coordh ) * y1 * -1;
                    $scope.resizing.newwidth = ( cw / coordw * width );
                    $scope.resizing.newheight = ( ch / coordh * height );
                }
            };

            parseData();
        }] // end controller

    }); // END return
});
